import { useSelector } from 'react-redux'
import { selectCompactMode } from '../../Slice/Application/ApplicationSlice.js'

export const useGetCompactMode = () => {
  return useSelector(selectCompactMode)
}
